<template>
    <div id="selfService" class="self-service">
        <accountContainer class="narrow narrow-sm" :sub-title-text="$t('login.help.trouble-logging-in')">
            <p class="self-service__welcome text-white text-center">{{ $t('self-service.welcome') }}</p>
            <p class="text-white text-center">{{ $t('self-service.select-options') }}</p>

            <div class="self-service__options">
                <button
                    class="self-service__options__item"
                    @click="
                        moveTo('self-reset-password', $t('self-service.reset-password.title', 'en', { lineBreak: '' }))
                    "
                >
                    <img src="@/images/self-service/reset-password.png" alt="reset password" />
                    <i18n path="self-service.reset-password.title" tag="span">
                        <template v-slot:lineBreak>
                            <br />
                        </template>
                    </i18n>
                </button>

                <button
                    class="self-service__options__item"
                    @click="moveTo('self-find-email', $t('self-service.find-email.title', 'en', { lineBreak: '' }))"
                >
                    <img src="@/images/self-service/find-email.png" alt="find email" />
                    <i18n path="self-service.find-email.title" tag="span">
                        <template v-slot:lineBreak>
                            <br />
                        </template>
                    </i18n>
                </button>

                <button
                    class="self-service__options__item"
                    @click="moveTo('self-change-email', $t('self-service.change-email.title', 'en', { lineBreak: '' }))"
                >
                    <img src="@/images/self-service/change-email.png" alt="change email" />
                    <i18n path="self-service.change-email.title" tag="span">
                        <template v-slot:lineBreak>
                            <br />
                        </template>
                    </i18n>
                </button>

                <button
                    class="self-service__options__item"
                    @click="moveTo('self-no-auth-access', $t('self-service.no-access-auth.title', 'en'))"
                >
                    <img src="@/images/self-service/cant-access.png" alt="can not access" />
                    <span>{{ $t('self-service.no-access-auth.title') }}</span>
                </button>
            </div>

            <div class="faqs-link-container">
                <a
                    class="text-uppercase"
                    :href="faqLinks[`${$store.state.region}`]"
                    target="_blank"
                    rel="external"
                    @click="trackOtherLinkClick($t('self-service.account-faqs', 'en'))"
                >
                    {{ $t('self-service.account-faqs') }}
                    <SvgIcons icon-holder-class="icon-help" icon-id="icon-page-right-blue" />
                </a>
            </div>

            <div class="clearfix"></div>

            <FormButton class="btn-primary" :button-click="backToLogin" :label="$t('self-service.back')"> </FormButton>
        </accountContainer>
    </div>
</template>

<script>
import { FormButton, SvgIcons } from '@arena/toolkit';
import accountContainer from '@/components/account-container';

export default {
    name: 'AccountSelfService',
    components: {
        accountContainer,
        FormButton,
        SvgIcons,
    },
    metaInfo() {
        return {
            titleTemplate: `%s | ${this.$t('login.help.trouble-logging-in')}`,
        };
    },
    data() {
        return {
            faqLinks: {
                global: 'https://playersupport.nexon.com/hc/en-us/categories/200262565-General',
                one: 'https://playersupport.nexon.com/hc/en-us/categories/200262565-General',
                th: 'https://th.nexon.com/forum/th/forum/283/board/663',
                tw: 'https://tw.nexon.com/forum/zh/forum/264/board/1361',
                sea: 'https://playersupport.nexon.com/hc/en-us/categories/200262565-General',
                japan: 'https://forum.nexon.com/kartdrift-jp/board_list?board=2624',
            },
        };
    },
    mounted() {
        this.$store.commit('selfService/setSerialNumber', ''); // reset serialNumber
        this.$store.commit('selfService/setOperationType', ''); // reset operationType
    },
    methods: {
        moveTo(routeName, buttonName) {
            dataLayer.push({
                event: 'accountRecoverySelfService_Start',
                'AR Button Name': buttonName,
            });

            this.$router.push({
                name: routeName,
            });
        },
        backToLogin() {
            this.$router.push({ name: 'login' });
            this.trackOtherLinkClick(this.$t('self-service.back', 'en'));
        },
        trackOtherLinkClick(name) {
            dataLayer.push({
                event: 'accountRecoverySelfService_OtherLinkClick',
                'AR Link Name': name,
            });
        },
    },
};
</script>

<style lang="less" scoped>
.self-service {
    &__welcome {
        margin-bottom: 0;
        font-weight: bold;
    }
    &__options {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        &__item {
            flex: 0 0 50%;
            max-width: calc(50% - 5px);
            display: flex;
            flex-wrap: wrap;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            white-space: normal;
            font-size: 14px;
            font-weight: bold;
            line-height: 1.3;
            background-color: #000;
            border-radius: 2px;
            padding: 20px 14px;
            color: #fff;
            &:hover {
                background-color: #4d4d4d;
            }
            img {
                margin-bottom: 16px;
                height: 100px;
                width: auto;
            }
            &:nth-child(n + 3) {
                margin-top: 10px;
            }
        }
    }
    ::v-deep .faqs-link-container {
        text-align: center;
        margin-top: 28px;
        margin-bottom: 12px;
        a {
            color: #0077ff;
            font-weight: bold;
            svg {
                height: 9px;
                width: 6px;
                margin-left: 3px;
                opacity: 0.8;
            }
            &:hover {
                color: #4ca1ff;
                svg {
                    opacity: 1;
                }
            }
        }
    }
}
</style>
